import { LaborEntryType } from '@hb/shared'
import { LaborEntryComponent } from '../types'
import { CervicalExamEntry } from './CervicalExam'
import { ContractionEntry } from './Contraction'
import { FHREntry } from './FHR'
import { MedicationEntry } from './Medication'
import { NarrativeEntry } from './Narrative'
import { ProcedureEntry } from './Procedure'
import { VitalsEntry } from './Vitals'

export const LaborEntryComponents: { [key in LaborEntryType]: LaborEntryComponent<key> } = {
  [LaborEntryType.VITALS]: VitalsEntry,
  [LaborEntryType.CERVICAL_EXAM]: CervicalExamEntry,
  [LaborEntryType.FHR]: FHREntry,
  [LaborEntryType.CONTRACTION]: ContractionEntry,
  [LaborEntryType.MEDICATION]: MedicationEntry,
  [LaborEntryType.NARRATIVE]: NarrativeEntry,
  [LaborEntryType.PROCEDURE]: ProcedureEntry,
}
